module.exports = __webpack_public_path__ + "static/media/8OLA25.66f9a53b.jpg";